import { combineReducers } from "redux";
import { settingsReducer } from "./settings";
import { loginSettingsReducer } from "./loginSettings";
import { PreferencesReducer, UserReducer } from "./user";

export const reducers = combineReducers({
	current_user: UserReducer,
	preferences: PreferencesReducer,
	settings: settingsReducer,
	loginSettings: loginSettingsReducer,
})